var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","placeholder":"Search Account..."},on:{"input":function($event){return _vm.set_value($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }